import * as React from 'react';
import { InlineChildren, Stack, StackChildren, Text, } from '@doordash/design-language';
import Button from '@doordash/component-button';
import { OptionImg, RecommendationTileContainer, ProductBodyContainer, } from '../QuizStyles';
import track from '../../../../utils/track';
import { QuizEvents } from '../../../../constants/events';
export var RecommendationTile = function (_a) {
    var product = _a.product, onActionClick = _a.onActionClick;
    var title = product.title, subtitle = product.subtitle, bodyArray = product.body, pricing = product.pricing, button = product.button, imageUrl = product.imageUrl;
    React.useEffect(function () {
        track(QuizEvents.RECOMMENDATION_VIEW, {
            product: title,
        });
    }, [title]);
    return (React.createElement(RecommendationTileContainer, null,
        React.createElement(StackChildren, null,
            React.createElement(StackChildren, null,
                imageUrl && React.createElement(OptionImg, { src: imageUrl }),
                React.createElement(Text, { styles: Text.Styles.Title2 }, title),
                React.createElement(Text, { styles: Text.Styles.Body1, color: Text.Colors.TextSecondary }, subtitle)),
            bodyArray.map(function (bodyData, index) { return (React.createElement("div", { key: index },
                React.createElement(Text, { styles: Text.Styles.Body2Emphasis }, bodyData.title),
                React.createElement(StackChildren, null,
                    React.createElement(ProductBodyContainer, null, bodyData.bullets.map(function (bullet, index) { return (React.createElement("li", { key: index },
                        React.createElement(Text, { styles: Text.Styles.Body2, color: Text.Colors.TextSecondary }, bullet))); }))))); }),
            pricing && (React.createElement("div", null,
                React.createElement(Text, { styles: Text.Styles.Body2Emphasis }, pricing.title),
                React.createElement(Text, { styles: Text.Styles.Body2, color: Text.Colors.TextSecondary }, pricing.subtitle))),
            React.createElement(Stack, { size: Stack.Sizes.XLarge }),
            React.createElement(InlineChildren, null,
                React.createElement(Button, { size: Button.Sizes.Small, isInline: true, onClick: onActionClick }, button.text)))));
};
